export default __webpack_public_path__ + "static/media/logo-tacr-min.bbe8ed55.svg";